module.exports = {
  apiHost: "https://api.vantagelilywood.sensoreal.app",
  assetsHost: "https://assets.vantagelilywood.sensoreal.app",
  brandName: "Vantage Lilywood",
  header: {
    text: { en: "Your Vantage Lilywood Selections" },
    logo: "",
    companyLogo: "",
    color: "#fff",
  },
  langs: [{ code: "en", dir: "ltr" }],
  style: {
    primaryColor: "#2f4b5b",
    textColor: "#fff",
    font: "Interstate",
  },
  contact: {
    website: "https://vantagelilywood.avid.com.au",
    address: "Lilywood QLD 4513",
    phone: "1800 545 993",
    email: "vantagelilywood@avid.com.au",
  },
  links: {
    privacy: "",
    youtube: "",
    linkedin: "",
    twitter: "",
    instagram: "https://www.instagram.com/avid_together/",
    facebook: "https://www.facebook.com/vantagebyAVID",
  },
  footerLogo:
    "https://static-mbh.sgp1.cdn.digitaloceanspaces.com/avid-edm/general/AVID_White_72dpi.png",
};
